import SalesContent from "../../../../src/pages/faq/sales-content.md";
import * as React from 'react';
export default {
  SalesContent,
  React
};